import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Bolanir - Libreria e Cartoleria Blog</title>
        <meta name="description" content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali." />
      </Helmet>

      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#2d4a3e', borderBottom: '2px solid #2d4a3e', paddingBottom: '10px' }}>
        Informativa sulla Privacy
      </h1>
      
      <p style={{ color: '#666', marginBottom: '20px' }}>
        <strong>Data di entrata in vigore:</strong> {new Date().toLocaleDateString('it-IT')}
      </p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>1. Introduzione</h2>
        <p>
          Benvenuto su Bolanir. La presente Informativa sulla Privacy descrive come raccogliamo, 
          utilizziamo, conserviamo e proteggiamo le informazioni personali degli utenti del nostro 
          blog dedicato alla letteratura, libri e cancelleria di qualità.
        </p>
        <p>
          Ci impegniamo a proteggere la tua privacy e a garantire la sicurezza dei tuoi dati personali 
          in conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR) e le normative 
          italiane sulla privacy.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>2. Titolare del Trattamento</h2>
        <p>
          Il Titolare del trattamento dei dati è Bolanir, con sede legale in Italia.
          Per qualsiasi domanda relativa alla presente informativa, puoi contattarci all'indirizzo 
          email: <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>3. Dati Raccolti</h2>
        <p>Raccogliamo le seguenti categorie di informazioni:</p>
        
        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>3.1 Dati forniti volontariamente</h3>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Nome e cognome</li>
          <li>Indirizzo email</li>
          <li>Commenti e recensioni sui nostri articoli</li>
          <li>Informazioni di contatto fornite tramite moduli</li>
          <li>Preferenze di lettura e interessi letterari</li>
        </ul>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>3.2 Dati raccolti automaticamente</h3>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Indirizzo IP</li>
          <li>Tipo di browser e dispositivo utilizzato</li>
          <li>Pagine visitate sul nostro sito</li>
          <li>Data e ora delle visite</li>
          <li>Pagina di provenienza e di uscita</li>
          <li>Dati di geolocalizzazione approssimativa</li>
        </ul>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>3.3 Cookie e tecnologie simili</h3>
        <p>
          Utilizziamo cookie, pixel di tracciamento e tecnologie simili per migliorare l'esperienza 
          utente e analizzare il traffico del sito. Per maggiori informazioni, consulta la nostra 
          Cookie Policy.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>4. Finalità del Trattamento</h2>
        <p>Utilizziamo i tuoi dati personali per le seguenti finalità:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Fornire e gestire i servizi del nostro blog</li>
          <li>Rispondere alle tue richieste e comunicazioni</li>
          <li>Pubblicare i tuoi commenti e recensioni</li>
          <li>Inviare newsletter e aggiornamenti sui nuovi contenuti (previo consenso)</li>
          <li>Personalizzare i contenuti in base ai tuoi interessi</li>
          <li>Migliorare la qualità e l'usabilità del sito</li>
          <li>Condurre analisi statistiche e di mercato</li>
          <li>Prevenire frodi e garantire la sicurezza del sito</li>
          <li>Adempiere agli obblighi di legge</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>5. Base Giuridica del Trattamento</h2>
        <p>Il trattamento dei tuoi dati personali si basa su:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li><strong>Consenso:</strong> per l'invio di newsletter e comunicazioni promozionali</li>
          <li><strong>Esecuzione del contratto:</strong> per fornire i servizi richiesti</li>
          <li><strong>Interesse legittimo:</strong> per migliorare i nostri servizi e garantire la sicurezza</li>
          <li><strong>Obbligo di legge:</strong> per adempiere agli obblighi normativi</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>6. Condivisione dei Dati</h2>
        <p>Possiamo condividere i tuoi dati personali con:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li><strong>Fornitori di servizi:</strong> hosting, email marketing, analytics (es. Google Analytics, Facebook Pixel)</li>
          <li><strong>Partner commerciali:</strong> editori, librerie e distributori di cancelleria con cui collaboriamo</li>
          <li><strong>Autorità competenti:</strong> quando richiesto dalla legge o per proteggere i nostri diritti</li>
          <li><strong>Terze parti:</strong> previa tua esplicita autorizzazione</li>
        </ul>
        <p>
          Non vendiamo né cediamo i tuoi dati personali a terzi per finalità di marketing senza il tuo consenso.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>7. Trasferimento Dati Extra-UE</h2>
        <p>
          Alcuni dei nostri fornitori di servizi (come Google Analytics e Facebook) potrebbero essere 
          localizzati al di fuori dell'Unione Europea. In tali casi, garantiamo che siano adottate 
          misure di protezione adeguate, come le Clausole Contrattuali Standard approvate dalla 
          Commissione Europea.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>8. Conservazione dei Dati</h2>
        <p>Conserviamo i tuoi dati personali per il tempo necessario a:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Fornire i servizi richiesti</li>
          <li>Adempiere agli obblighi di legge (generalmente 10 anni per finalità fiscali)</li>
          <li>Gestire eventuali controversie legali</li>
        </ul>
        <p>
          I dati utilizzati per finalità di marketing saranno conservati fino alla revoca del consenso 
          o per un massimo di 24 mesi dall'ultima interazione.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>9. I Tuoi Diritti</h2>
        <p>In conformità con il GDPR, hai i seguenti diritti:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li><strong>Accesso:</strong> ottenere informazioni sui dati che trattiamo</li>
          <li><strong>Rettifica:</strong> correggere dati inesatti o incompleti</li>
          <li><strong>Cancellazione:</strong> richiedere la cancellazione dei tuoi dati ("diritto all'oblio")</li>
          <li><strong>Limitazione:</strong> limitare il trattamento in determinate circostanze</li>
          <li><strong>Portabilità:</strong> ricevere i tuoi dati in formato strutturato</li>
          <li><strong>Opposizione:</strong> opporti al trattamento per finalità di marketing o interesse legittimo</li>
          <li><strong>Revoca del consenso:</strong> revocare il consenso in qualsiasi momento</li>
          <li><strong>Reclamo:</strong> presentare reclamo all'Autorità Garante per la Protezione dei Dati Personali</li>
        </ul>
        <p>
          Per esercitare i tuoi diritti, contattaci all'indirizzo: <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>10. Sicurezza dei Dati</h2>
        <p>
          Adottiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati personali 
          da accessi non autorizzati, perdita, distruzione o alterazione, tra cui:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Crittografia SSL/TLS per le comunicazioni</li>
          <li>Firewall e sistemi di rilevamento delle intrusioni</li>
          <li>Accesso limitato ai dati solo al personale autorizzato</li>
          <li>Backup regolari dei dati</li>
          <li>Formazione del personale sulla protezione dei dati</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>11. Cookie e Tecnologie di Tracciamento</h2>
        <p>
          Il nostro sito utilizza cookie tecnici, analitici e di profilazione. Utilizziamo:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li><strong>Google Analytics:</strong> per analizzare il comportamento degli utenti</li>
          <li><strong>Facebook Pixel:</strong> per tracciare le conversioni e ottimizzare le campagne pubblicitarie</li>
          <li><strong>Cookie tecnici:</strong> necessari per il funzionamento del sito</li>
        </ul>
        <p>
          Puoi gestire le preferenze sui cookie attraverso il banner presente sul sito o le 
          impostazioni del tuo browser.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>12. Link a Siti Terzi</h2>
        <p>
          Il nostro blog può contenere link a siti web di terze parti (editori, librerie online, 
          rivenditori di cancelleria). Non siamo responsabili delle pratiche sulla privacy di tali 
          siti e ti invitiamo a leggere le loro informative sulla privacy.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>13. Minori</h2>
        <p>
          I nostri servizi non sono destinati a minori di 16 anni. Non raccogliamo consapevolmente 
          dati personali da minori. Se veniamo a conoscenza di aver raccolto dati di un minore, 
          procederemo alla loro cancellazione immediata.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>14. Modifiche all'Informativa</h2>
        <p>
          Ci riserviamo il diritto di modificare la presente Informativa sulla Privacy in qualsiasi 
          momento. Le modifiche saranno pubblicate su questa pagina con l'indicazione della data di 
          aggiornamento. Ti invitiamo a consultare periodicamente questa pagina per rimanere informato.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>15. Contatti</h2>
        <p>
          Per qualsiasi domanda, dubbio o richiesta relativa alla presente Informativa sulla Privacy 
          o al trattamento dei tuoi dati personali, puoi contattarci:
        </p>
        <ul style={{ lineHeight: '1.8', listStyle: 'none', paddingLeft: 0 }}>
          <li><strong>Email:</strong> <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a></li>
          <li><strong>Email generale:</strong> <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a></li>
          <li><strong>Sito web:</strong> www.bolanir.com</li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          <strong>Autorità di controllo:</strong> Garante per la Protezione dei Dati Personali<br />
          Piazza Venezia 11, 00187 Roma<br />
          Tel. +39 06 696771<br />
          www.garanteprivacy.it
        </p>
      </section>

      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f5f5f5', borderLeft: '4px solid #2d4a3e' }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
          Utilizzando il nostro sito, accetti la presente Informativa sulla Privacy e acconsenti 
          al trattamento dei tuoi dati personali come descritto in questo documento.
        </p>
      </div>
    </div>
  
    </>);
};

export default PrivacyPolicy;